import { Box, Typography } from "@mui/material";
import { Image } from "./image";
import React from "react";
import Footer from "./footer";

export const Gallery = (props) => {
  console.log('props :>> ', props);
  return (
    <div id="portfolio" className="text-center" style={{marginTop:-100,backgroundColor:"#d9d9d9", marginBottom:-40 }}>
      <div style={{backgroundColor:"#03203f"}}>
        <div className="container" style={{marginBottom:"3rem"}}>
          <div className="section-title">
            <h2 style={{ color: "#d9d9d9" }}>Gallery </h2>
          
          </div>
           <Box sx={{padding: {xs: 4, sm: 4,  md: 4,}}}>
            <Typography variant="h2" sx={{ fontWeight: "bold", mb: 3 ,textAlign:"left"}}>
              <span style={{ color: "#d9d9d9" }}> Ongoing </span><span style={{ color: "#009bd6" }}>Projects</span>
              </Typography>
            <div className="row" style={{marginBottom:"5rem"}}>
              <div className="portfolio-items">
                {props.ongoing
                  ? props.ongoing.map((d, i) => (
                      <div
                        key={`${d.title}-${i}`}
                        className="col-sm-6 col-md-4 col-lg-4"
                      >
                        <Image
                          title={d.title}
                          largeImage={d.largeImage}
                          smallImage={d.smallImage}
                        />
                      </div>
                    ))
                  : "Loading..."}
              </div>
            </div>
           </Box>
        </div>
      </div>
      
      <div style={{backgroundColor:"#d9d9d9"}} >
        <div className="container"  >
          <Box mt={3} sx={{padding: {xs: 4, sm: 4,  md: 4,}}}>
          <Typography variant="h2" sx={{ fontWeight: "bold", mb: 3 ,textAlign:"left"}}>
          <span style={{ color: "#03203f" }}> Completed </span> <span style={{ color: "#009bd6" }}>Projects</span>
            </Typography>
          <div className="row">
            <div className="portfolio-items">
              {props.completed
                ? props.completed.map((d, i) => (
                    <div
                      key={`${d.title}-${i}`}
                      className="col-sm-6 col-md-4 col-lg-4"
                    >
                      <Image
                        title={d.title}
                        largeImage={d.largeImage}
                        smallImage={d.smallImage}
                      />
                    </div>
                  ))
                : "Loading..."}
            </div>
          </div>
          </Box>
        </div>
      </div>
    </div>
  );
};
